<template>
    <div class="olf-wave-background d-flex justify-content-center align-items-center">
        <div class="login-sequence-box card"
            :class="[$breakpoint.xsOnly ? 'p-4' : 'p-5']"
        >
            <img src="/assets/rebrandLogo2.png" alt="Online Fuels Logo" class="d-block mb-5 logo" />
            <password-form v-if="!passwordChanged" :isUserLoggedIn="false" @passwordResetCompleted="passwordResetCompleted()" />
            <div class="text-center" v-else>
                <p>Your password has been changed successfully</p>
                <button @click="goToLogin" class="btn btn-secondary">Go to login page</button>
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import PasswordForm from "@/components/Login/PasswordForm.vue";

export default {
    mixins: [breakpoint],
    components: {
        PasswordForm
    },
    data() {
        return {
            passwordChanged: false
        }
    },
    methods: {
        passwordResetCompleted: function() {
            this.passwordChanged = true;
        },
        goToLogin: function() {
            this.$router.push({name:'Login'});
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/_logins.scss";
</style>